import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Link } from '@react-pdf/renderer'
import { aChoiceData, bChoiceData, cChoiceData, dChoiceData, pdfTexts } from '../Data/data'
import logo from '../Content/hankelogo.jpg'
import { getFormattedDate } from '../Utils/helpers'

const Doc1 = (props) => {

  // Font.register({ 
  //   family: 'Roboto', 
  //   fonts: [
  //     {
  //       src: 'https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf',
  //       fontWeight: 300
  //     },
  //     {
  //       src: 'https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmEU9vAx05IsDqlA.ttf',
  //       fontWeight: 500
  //     }
  //   ] 
  // })

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 35,
      paddingHorizontal: 35,
      // fontFamily: 'Roboto'
    },
    headerContainer: {
      flexDirection: 'row',
      flexGrow: 1,
      alignItems: 'center',
      paddingBottom: 20
    },
    logo: {
      paddingVertical: 0,
      paddingHorizontal: 0,
      height: '80px',
      width: '113px'
    },
    header: {
      fontSize: 25,
      margin: 'auto',
    },
    section: {
      marginTop: 20,
      marginBottom: 0,
      flexDirection: 'row',
      flexGrow: 1,
      textAlign: 'justify'
    },
    subHeader: {
      paddingBottom: 5,
      marginBottom: 0,
      fontSize: 18
    },
    text: {
      paddingVertical: 10,
      paddingHorizontal: 0,
      fontSize: 12,
    },
    imageContainer: {
      margin: 'auto'
    },
    images: {
      paddingVertical: 0,
      paddingHorizontal: 0,
      height: '90%vh',
      width: '90%vh',
      backgroundColor: '#ffffff'
    },
    footer: {
      fontSize: 10,
      flexDirection: 'row',
      flexGrow: 1,
      justifyContent: 'space-between',
    }
  });

  return (
    <Document>
      <Page size="A4" style={styles.body}>
          <View style={styles.headerContainer}>
            <Image src={logo} alt="hankelogo" style={styles.logo} />
            <Text style={styles.header}>{pdfTexts.mainHeader1}</Text><br />
          </View>
          <View style={styles.section}>
            <Text style={styles.subHeader}>{pdfTexts.subHeader1}</Text>
          </View>
          <View>
            <Text style={styles.text}>- {aChoiceData.title + " " + aChoiceData.options["option" + props.all[0]].text}.</Text>
            <Text style={styles.text}>- {bChoiceData.title + " " + bChoiceData.options["option" + props.all[1]].text}.</Text>
            <Text style={styles.text}>- {cChoiceData.title + " " + cChoiceData.options["option" + props.all[2]].text}.</Text>
            <Text style={styles.text}>- {dChoiceData.title + " " + dChoiceData.options["option" + props.all[3]].text}.</Text>
          </View>
          <View style={styles.imageContainer}>
            <Image src={props.image} alt="images" style={styles.images}/>
          </View>
          <View style={styles.footer}>
            <Text>{pdfTexts.linkText}{<Link>{pdfTexts.link}</Link>}</Text>
            <Text>{getFormattedDate()}</Text>
          </View>
      </Page>
    </Document>
  );
};

export default Doc1;